import React from 'react'
import { Helmet } from 'react-helmet';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';

import TableSpecs from '../components/tableSPECS'
import SEO from '../components/seov2'

import "normalize.css"

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  grid: {
    margin: '.5rem .5rem'
  },
  gridY: {
    margin: '.25rem 0'
  },
  MuiCard: {
    '& .MuiCardHeader-root': {
      padding: `${theme.spacing(2)}px`,
      '& .MuiCardHeader-content': {
        fontSize: '1rem',
        fontWeight: '600',
        color: '#000',
        textTransform: 'uppercase',
        textAlign: 'center',
      },
    },
    '& .MuiCardContent-root': {
      padding: `${theme.spacing(2)}px`,
      '& .MuiTypography-root': {
        fontWeight: '400',
        fontSize: '1.25rem',
        color: '#000',
        textAlign: 'center',
        '& small': {
          fontWeight: '200',
        }
      },
    },
  },
  BRRigth: {
    borderRadius: '4px 0 0 4px'
  },
  BRLeft: {
    borderRadius: '0 4px 4px 0'
  },
  BRTop: {
    borderRadius: '4px 4px 0 0'
  },
  BRBottom: {
    borderRadius: ' 0 0 4px 4px'
  },
  h1resultado: {
    //backgroundColor:"#DC2626",
    textDecoration: 'wavy underline  #111827',
    color: '#DC2626',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '.15rem',
    lineHeight: '2.5rem',
    textAlign: 'center',
    borderRadius: 4,
    padding: 4
  },
  h1atual: {
    //backgroundColor:"#059669",
    textDecoration: 'wavy underline  #111827',
    color: '#059669',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '.15rem',
    lineHeight: '2.5rem',
    textAlign: 'center',
    borderRadius: 4,
    padding: 4
  },
  h1quest: {
    //backgroundColor:"#2563EB",
    textDecoration: 'wavy underline  #111827',
    color: '#2563EB',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '.15rem',
    lineHeight: '2.5rem',
    textAlign: 'center',
    borderRadius: 4,
    padding: 4
  },
  objtmb: {
    '& > div': {
      borderTop: '1px dashed #9CA3AF',
      padding: `${theme.spacing(.5)}px 0`
    },
    '& > div:first-child': {
      borderTop: 'none',
    }
  },

  instagram: {
    display: 'inline-block',
    // width: '250px',
    height: '32px',
    textAlign: 'center',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '.5rem',
    //lineHeight: '250px',
    verticalAlign: 'middle',
    background: '#d6249f radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)',
    boxShadow: '0px 3px 10px rgba(0,0,0,.25)',
  }

}));

class ModeloCorporal {
  constructor(Altura, Peso, Idade, Sexo, IATOcupacao, IATLazer, PesoPGC, DsjPG) {
    this.Altura = parseFloat(Altura)
    this.Peso = parseFloat(Peso)
    this.Idade = parseFloat(Idade)
    this.Sexo = Sexo
    this.IATOcupacao = IATOcupacao
    this.IATLazer = IATLazer
    this.PesoPGC = PesoPGC
    this.DsjPG = parseFloat(DsjPG)
  }

  get objPeso() {
    return this.Peso - this.objPMGorda();
  }

  get TMBvsIAF() {
    return Math.round(this.TMB() * this.IAF())
  }

  get MGorda() {
    return (
      {
        'por': Math.round(this.PGC()),
        'kg': Math.round(Math.round(this.PGC()) * this.Peso / 100)
      }
    )
  }

  get MMagra() {
    var kgMMagra = this.Peso - Math.round(Math.round(this.PGC()) * this.Peso / 100)
    return (
      {
        'por': Math.round((kgMMagra / this.Peso) * 100),
        'kg': kgMMagra
      }
    )
  }

  get MAgua() {
    return (
      {
        'por': Math.round(this.AEC() / this.Peso * 100),
        'kg': Math.round(this.AEC())
      }
    )
  }

  get objTMBvsIAF() {
    var atualpgc = Math.round(Math.round(this.PGC()) * this.Peso / 100)
    var objpgc = atualpgc - this.objPMGorda()
    var diffpgc = atualpgc - objpgc
    //console.log(atualpgc, objpgc, diffpgc)

    var bagTMB = [];
    var pesoS = this.Peso
    var accsubpeso = 0

    for (var i = 0; i < Math.round(diffpgc / 4); i++) {
      var TMB = 0
      var subpeso = ((i * 4) + accsubpeso > diffpgc) ? diffpgc - accsubpeso : 4

      pesoS -= accsubpeso

      if (this.Sexo === "masculino") {
        TMB = ((9.99 * pesoS) + (625.0 * (this.Altura / 100.0)) - (4.92 * this.Idade) + 5.0);
      } else {
        TMB = ((9.99 * pesoS) + (625.0 * (this.Altura / 100.0)) - (4.92 * this.Idade) - 161.0);
      }

      accsubpeso += subpeso
      bagTMB.push(
        {
          'kcal': (Math.round(TMB * this.IAF()) - 500),
          'kgAtual': pesoS,
          'kgObj': this.Peso - accsubpeso,
          'mes': i + 1
        }
      )

    }

    //console.log(bagTMB)
    return bagTMB

  }

  get PMGorda() {
    return this.objPMGorda()
  }

  update(Altura, Peso, Idade, Sexo, IATOcupacao, IATLazer, PesoPGC, DsjPG) {
    this.Altura = parseFloat(Altura)
    this.Peso = parseFloat(Peso)
    this.Idade = parseFloat(Idade)
    this.Sexo = Sexo
    this.IATOcupacao = IATOcupacao
    this.IATLazer = IATLazer
    this.PesoPGC = PesoPGC
    this.DsjPG = parseFloat(DsjPG)
  }

  //https://doi.org/10.1111/j.1467-789x.2006.00249.x
  IAF() {
    var activityLevelValue = 0
    switch (this.IATLazer + "|" + this.IATOcupacao) {
      default:
        activityLevelValue = 1.6;
        break;
      case "muitoleve|muitoleve":
        activityLevelValue = 1.4;
        break;
      case "muitoleve|leve":
        activityLevelValue = 1.5;
        break;
      case "muitoleve|moderado":
        activityLevelValue = 1.6;
        break;
      case "muitoleve|pesado":
        activityLevelValue = 1.7;
        break;
      case "leve|muitoleve":
        activityLevelValue = 1.5;
        break;
      case "leve|leve":
        activityLevelValue = 1.6;
        break;
      case "leve|moderado":
        activityLevelValue = 1.7;
        break;
      case "leve|pesado":
        activityLevelValue = 1.8;
        break;
      case "moderado|muitoleve":
        activityLevelValue = 1.6;
        break;
      case "moderado|leve":
        activityLevelValue = 1.7;
        break;
      case "moderado|moderado":
        activityLevelValue = 1.8;
        break;
      case "moderado|pesado":
        activityLevelValue = 1.9;
        break;
      case "ativo|muitoleve":
        activityLevelValue = 1.7;
        break;
      case "ativo|Light":
        activityLevelValue = 1.8;
        break;
      case "ativo|moderado":
        activityLevelValue = 1.9;
        break;
      case "ativo|pesado":
        activityLevelValue = 2.1;
        break;
      case "muitoativo|muitoleve":
        activityLevelValue = 1.9;
        break;
      case "muitoativo|leve":
        activityLevelValue = 2.0;
        break;
      case "muitoativo|moderado":
        activityLevelValue = 2.2;
        break;
      case "muitoativo|pesado":
        activityLevelValue = 2.3;
        break;
    }
    return activityLevelValue;
  }

  //https://pubmed.ncbi.nlm.nih.gov/2305711/
  TMB() {

    var TMB = 0;

    if (this.Sexo === "masculino") {
      TMB = (9.99 * this.Peso + 625.0 * this.Altura / 100.0 - 4.92 * this.Idade + 5.0);
    } else {
      TMB = (9.99 * this.Peso + 625.0 * this.Altura / 100.0 - 4.92 * this.Idade - 161.0);
    }

    return TMB;
  }

  //https://dx.doi.org/10.1097%2FNT.0000000000000092
  IMC() {
    return this.Peso / Math.pow(this.Altura / 100.0, 2.0);
  }

  //https://pubmed.ncbi.nlm.nih.gov/12037649/
  PGC() {
    var PGC = 0;
    if (this.Sexo === "masculino") {
      PGC = (0.14 * this.Idade + 37.310000000000002 * Math.log(this.IMC()) - 103.94);
    } else {
      PGC = (0.14 * this.Idade + 39.960000000000001 * Math.log(this.IMC()) - 102.01000000000001);
    }
    PGC = (PGC < 0.0) ? 0.0 : PGC;
    PGC = (PGC > 60.0) ? 60.0 : PGC;
    return PGC;
  }

  //https://sci-hub.se/https://pubmed.ncbi.nlm.nih.gov/17470983/
  AEC() {
    var AEC
    if (this.Sexo === "masculino") {
      AEC = (0.025 * this.Idade) + (9.57 * (this.Altura / 100)) + (0.191 * this.Peso) - 12.4;
    } else {
      AEC = -4.0 + (5.98 * (this.Altura / 100)) + (0.167 * this.Peso);
    }
    return AEC;
  }

  objPMGorda() {
    var pgcl = 0

    if (this.PesoPGC === "objtpeso") {
      pgcl = this.Peso - this.DsjPG;

    } else {
      pgcl = this.Peso - Math.round((this.MMagra.kg / (100 - this.DsjPG)) * 100);
    }
    return pgcl
  }

}

const IndexPage = (s) => {

  const classes = useStyles();
  const theme = useTheme();
  const matchesBK = useMediaQuery(theme.breakpoints.down('xs'));
  const downXS = useMediaQuery(theme.breakpoints.down('xs'));

  const [Altura, setAltura] = React.useState(175);

  const handleChangeAltura = (event) => {
    setAltura(event.target.value);
  };

  const [Peso, setPeso] = React.useState(74);

  const handleChangePeso = (event) => {
    setPeso(event.target.value);
  };

  const [Idade, setIdade] = React.useState(29);

  const handleChangeIdade = (event) => {
    setIdade(event.target.value);
  };

  const [Sexo, setSexo] = React.useState('masculino');

  const handleChangeSexo = (event) => {
    setSexo(event.target.value);
  };

  const [IATOcupacao, setIATOcupacao] = React.useState('leve');

  const handleChangeIATOcupacao = (event) => {
    setIATOcupacao(event.target.value);
  };

  const [IATLazer, setIATLazer] = React.useState('leve');

  const handleChangeIATLazer = (event) => {
    setIATLazer(event.target.value);
  };

  const [TMVisitor, setTMVisitor] = React.useState(0);
  const handleChangeTMVisitor = (value) => {
    setTMVisitor(value);
  };

  const [MMVisitor, setMMVisitor] = React.useState();
  const handleChangeMMVisitor = (value) => {
    setMMVisitor(value);
  };

  const [GCVisitor, setGCVisitor] = React.useState();
  const handleChangeGCVisitor = (value) => {
    setGCVisitor(value);
  };

  const [AGVisitor, setAGVisitor] = React.useState();
  const handleChangeAGVisitor = (value) => {
    setAGVisitor(value);
  };

  var CorpoVisitante = new ModeloCorporal(Altura, Peso, Idade, Sexo, IATOcupacao, IATLazer, 70, 'objtpeso')
  //console.log(test.MGorda, test.MMagra, test.MAgua)

  React.useEffect(() => {
    // Side-effect uses `prop` and `state`
    CorpoVisitante.update(Altura, Peso, Idade, Sexo, IATOcupacao, IATLazer, 70, 'objtpeso')
    handleChangeTMVisitor(CorpoVisitante.TMBvsIAF)
    handleChangeMMVisitor(CorpoVisitante.MMagra)
    handleChangeGCVisitor(CorpoVisitante.MGorda)
    handleChangeAGVisitor(CorpoVisitante.MAgua)

  }, [Altura, Peso, Idade, Sexo, IATOcupacao, IATLazer, downXS]);

  return (
    <>

      <Helmet>

        <style>
          {`html {
              scrollbar-color: #666 #201c29;
              background-color: none;
              color: none;
              overflow-x: hidden;
              font-family: Roboto, Verdana, Geneva, Tahoma, sans-serif;
          }
          body{
              margin: 0 0 0 0;
              padding: 0 0 0 0;
          }

          body:after {
              content: "";
              background: none
          }

          body:after,body:before {
              display: none;
              height:none;
              position: none;
              top: none;
              left: none;
              width: none;
          }

          body:before {
              background-size: none
          }

          body:after,body:before {
              -webkit-clip-path: none;
              clip-path: none
          }

          main {
              position: relative;
              z-index: 1;
          }`}
        </style>

        <style>
          {
            `
          @keyframes gradientMoviment {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
          @keyframes gradientMoviment2 {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
          `
          }
        </style>


      </Helmet>

      <SEO />

      {/* header navbar */}
      <Grid container direction="row" wrap="wrap" justify='center' alignItems="center" alignContent="center"
        xs={12} sm={12} md={12} lg={12} xl={12}
        style={{ backgroundColor: '#ECFDF5', }}
      >
        <Grid container direction="row" wrap="wrap" justify='center' alignItems="center" alignContent="center"
          xs={12} sm={12} md={12} lg={12} xl={12}
          style={{
            margin: 'auto', padding: '16px',
            background: 'linear-gradient(135deg, #10B981 33%, #047857 66%, #064E3B 100%)',
            backgroundSize: '200% 200%',
            animation: 'gradientMoviment 15s ease infinite',
            clipPath: 'polygon(0 0, 100% 0, 100% 80%, 0 100%)'
          }}
        >
          <Grid container direction="row" wrap="wrap" justify="space-between" alignItems="center" alignContent="center"
            xs={12} sm={12} md={12} lg={10} xl={10}>

            <a href="https://infonutrientes.com.br" rel="noreferrer" target="_blank" style={{textDecoration: 'none'}}>
              <Typography component="h1" variant="h5" gutterBottom
                style={{ color: '#fff', fontWeight: "900", }}
              //border:'1px solid #047857', padding:'4px', borderRadius:'8px', backgroundColor:"#064E3B"
              >
                INFO Nutrientes
              </Typography>
            </a>

            <div>
              <a href="https://www.facebook.com/infonutrientes" rel="noreferrer" target="_blank">
                <FacebookIcon style={{ fill: '#fff', margin: '0 16px 0 0' }} />
              </a>
              <a href="https://www.instagram.com/infonutrientes" rel="noreferrer" target="_blank">
                <InstagramIcon style={{ fill: '#fff' }} />
              </a>
            </div>

          </Grid>
        </Grid>
      </Grid>

      {/* main content */}
      <Grid container direction="row" wrap="wrap" justify="center" alignItems="center" alignContent="center"
        xs={12} sm={12} md={12} lg={12} xl={12}
        style={{ margin: 'auto', padding: '0', backgroundColor: "#ECFDF5" }}
      >

        {/* frase */}
        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}
          justify="center" alignItems="center" alignContent="center"
        //style={{backgroundColor:'#374151'}}
        >
          <Typography component="p" variant="body1"
            style={{ padding: '8px 0', textAlign: "center", color: '#111827', fontsize: '.75rem', fontWeight: "300", letterSpacing: '.15rem' }}
          >
            sua saúde é o reflexo da sua alimentação
          </Typography>
        </Grid>

        {/* header title top*/}
        <Grid container xs={12} sm={12} md={12} lg={10} xl={10}
            justify="center" alignItems="center" alignContent="center"
            //className={classes.grid}
            style={{
              textAlign: "center",
              background:'linear-gradient(135deg, #10B981 33%, #047857 66%, #064E3B 100%)',
              backgroundSize:'200% 200%',
              animation:'gradientMoviment 15s ease infinite',
              clipPath: 'polygon(0 20%, 100% 0, 100% 100%, 0 100%)',
              //transform:'rotate(1deg)',
              //borderRadius:'1rem 1rem 0 0',
            }}
          >
            <Typography component="h1" variant="h5" gutterBottom
              style={{
                color:'white',
                fontWeight:'bold',
                fontSize:'2rem',
                //transform:'rotate(-1deg)',
                padding:'1rem 0',
                margin:'1rem 0 0',
                lineHeight:'1.75rem'
              }}>
              Cálculo dos Macronutrientes para Planejamento Alimentar
            </Typography>
          </Grid>

        {/* main content container */}
        <Grid
          container direction="row" wrap="wrap" justify="center" alignItems="center" alignContent="center"
          spacing={0} xs={12} sm={12} md={12} lg={10} xl={10}
          elevation={3}
          className={'MuiPaper-root MuiPaper-elevation8 MuiPaper-rounded'}
          style={{
            padding: '1.5rem auto',
            //marginBottom: '1.5rem',
            background: 'linear-gradient(90deg, #F9FAFB 33%, #FFFBEB 66%, #FEF2F2 100%)',
            backgroundSize: '500% 500%',
            animation: 'gradientMoviment2 15s ease infinite'
          }}
        >

          <Grid container xs={12} sm={12} md={12} lg={10} xl={10}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <Typography component="h1" variant="h5" gutterBottom
              className={classes.h1quest}>
              Qual a sua condição atual?
            </Typography>
          </Grid>

          {/* #altura */}
          <Grid container xs={6} sm={5} md={5} lg={5} xl={5}
            justify="flex-end" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <TextField
              label="Altura"
              id="altura"
              InputProps={{
                endAdornment: <InputAdornment position="start">cm</InputAdornment>,
              }}
              variant="outlined"
              onChange={handleChangeAltura}
            />
          </Grid>

          {/* #peso */}
          <Grid container xs={6} sm={5} md={5} lg={5} xl={5}
            justify="flex-start" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <TextField
              label="Peso"
              id="peso"
              InputProps={{
                endAdornment: <InputAdornment position="start">kg</InputAdornment>,
              }}
              variant="outlined"
              onChange={handleChangePeso}
            />
          </Grid>

          {/* #idade */}
          <Grid container xs={6} sm={5} md={5} lg={5} xl={5}
            justify="flex-end" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <TextField
              label="Idade"
              id="idade"
              InputProps={{
                endAdornment: <InputAdornment position="start">anos</InputAdornment>,
              }}
              variant="outlined"
              onChange={handleChangeIdade}
            />
          </Grid>

          {/* #sexo */}
          <Grid container xs={6} sm={5} md={5} lg={5} xl={5}
            justify="flex-start" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <FormControl variant="outlined" style={{ minWidth: 150 }}>
              <InputLabel id="sexo-label">Sexo</InputLabel>
              <Select
                labelId="sexo-label"
                id="sexo"
                value={Sexo}
                onChange={handleChangeSexo}
                label="Sexo"
              >
                <MenuItem value={'masculino'}>Masculino</MenuItem>
                <MenuItem value={'feminino'}>Feminino</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid container xs={12} sm={12} md={12} lg={10} xl={10}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <Typography component="h1" variant="h5" gutterBottom
              className={classes.h1quest}>
              Qual a intensidade de atividade física no seu dia a dia?
            </Typography>
          </Grid>

          {/* #iat-ocupacao */}
          <Grid container xs={12} sm={12} md={12} lg={10} xl={10}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <FormControl component="fieldset">

              <FormLabel component="div">
                <Typography component="span" variant="body1" gutterBottom
                  style={{color:'#2563EB',fontWeight:'bold', fontSize:'1.125rem'}}
                >
                  Na sua ocupação
                </Typography>
              </FormLabel>

              <RadioGroup aria-label="na sua ocupacao" name="iat-ocupacao" value={IATOcupacao} onChange={handleChangeIATOcupacao}>

                <FormControlLabel value="muitoleve" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Trabalho sedentário, fica em frente ao computador a maior parte do dia ou sentado em uma mesa, quase sem atividade." />

                <FormControlLabel value="leve" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Trabalhos industriais leves, vendas ou escritórios que incluam atividade leve." />

                <FormControlLabel value="moderado" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Tralhos de limpeza, profissional de cozinha, entrega de objetos a pé ou de bicicleta, do lar, atividade moderada" />

                <FormControlLabel value="ativo" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Trabalhos industriais pesados, trabalhos de construção ou agricultura, atividade pesada" />

              </RadioGroup>
            </FormControl>

          </Grid>

          {/* #iat-lazer */}
          <Grid container xs={12} sm={12} md={12} lg={10} xl={10}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <FormControl component="fieldset">

              <FormLabel component="div">
                <Typography component="span" variant="body1" gutterBottom
                  style={{color:'#2563EB',fontWeight:'bold', fontSize:'1.125rem'}}
                >
                  No seu lazer
                </Typography>
              </FormLabel>

              <RadioGroup aria-label="no seu lazer" name="iat-lazer" value={IATLazer} onChange={handleChangeIATLazer}>

                <FormControlLabel value="muitoleve" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Quase nenhuma atividade, quase sem atividade." />

                <FormControlLabel value="leve" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Caminhada, trilha de bicicleta com menos de 10km ou passatempo com pouca atividade e leve uma vez por semana." />

                <FormControlLabel value="moderado" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Atividade regular pelo menos uma vez por semana, como: caminhar, andar de bicicleta (inclusive para o trabalho) ou passatempo com atividade moderada." />

                <FormControlLabel value="ativo" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Atividades físicas regulares por mais de uma vez por semana, como: caminhada intensa, ciclismo mais 20km, academia ou esportes." />

                <FormControlLabel value="muitoativo" control={<Radio />} style={{ maxWidth: 720, marginTop: '.5rem' }}
                  label="Atividades físicas regulares por mais de quatro vezes por semana, como: caminhada intensa, ciclismo mais 20km, academia ou esportes." />

              </RadioGroup>
            </FormControl>

          </Grid>

          <Grid container xs={12} sm={12} md={12} lg={12} xl={12}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <Typography component="h1" variant="h5" gutterBottom
              className={classes.h1resultado}
            >
              seu resultado<br />
            </Typography>
          </Grid>

          <Divider />

          <Grid container xs={12} sm={12} md={12} lg={8} xl={7}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
            id='visitor-results'
          >
            <TableSpecs tm={TMVisitor} mm={MMVisitor} mg={GCVisitor} ag={AGVisitor} />

          </Grid>

          {/* rede social */}
          <Grid container xs={12} sm={12} md={12} lg={12} xl={12}
            justify="center" alignItems="center" alignContent="center"
            className={classes.grid}
          >
            <Typography component="h1" variant="h5" gutterBottom
              className={classes.h1quest}>
              Siga nossas redes socais para mais informações
            </Typography>
          </Grid>

          <Grid container xs={11} sm={11} md={11} lg={11} xl={11}
            className={classes.grid}
            //style={{backgroundColor:'#FECACA'}}
            direction="row"
            justify="center" alignItems="center" alignContent="center"
          >
            


            <Grid item xs={12} sm={12} md={12} lg={5} xl={5}
                  justify="center" alignItems="center" alignContent="center"
                  style={{ display: 'flex', padding: '1rem', borderRadius: '16px', backgroundColor: '#FECACA', marginLeft: `${downXS ? '0' : '1rem'}`, marginBottom: `${downXS ? '1rem' : '0'}`, alignItems: 'center' }}
            >

                  <iframe src={"https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Finfonutrientes%2F&tabs&width=340&height=70&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=2918888014996667"}
                    width={"340"} height={"70"} style={{ marginBottom: '0', border: 'none', overflow: 'hidden' }} scrolling={"no"} frameBorder={"0"} allowfullScreen={"true"}
                    allow={"autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"}
                  >
                  </iframe>

            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={5} xl={5}
                  justify="center" alignItems="center" alignContent="center"
                  style={{ display: 'flex', justifyContent:'center', padding: '1rem', borderRadius: '16px', backgroundColor: '#FECACA', marginLeft: `${downXS ? '0' : '1rem'}`, marginBottom: `${downXS ? '1rem' : '0'}`, alignItems: 'center' }}
                >

                  <a href="https://www.instagram.com/infonutrientes" rel="noreferrer" target="_blank"
                    style={{ marginRight: '.5rem' }}
                  >
                    < img width="36px" height="36px" alt={"infonutrientes, sua saúde é o reflexo da sua alimentação"}
                      style={{ margin: '0 0 0 0' }}
                      src='data:image/svg+xml;base64,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'
                    />
                  </a>

                  <Button variant="outlined" href="https://www.instagram.com/infonutrientes" rel="noreferrer" target="_blank">
                    {/* <p style={{ fontWeight:'bold', marginLeft: '1rem', marginBottom: '0' }}> */}
                      Siga no instagram
                    {/* </p> */}
                  </Button>

                </Grid>
              

          
          </Grid>
          
        {/* referencias */}
        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}
          justify="left" alignItems="center" alignContent="center"
          className={classes.grid}
        >
          <Typography component="h3" variant="h3" gutterBottom style={{ width: '100%', display: 'block', marginTop: '1rem', fontSize: '1.25rem' }}>
            Referências
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[1] Mifflin MD, St Jeor ST, Hill LA, Scott BJ, Daugherty SA, Koh YO. A new predictive equation for resting energy expenditure in healthy individuals. Am J Clin Nutr. 1990 Feb;51(2):241-7. doi: 10.1093/ajcn/51.2.241. PMID: 2305711.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[2] Nuttall FQ. Body Mass Index: Obesity, BMI, and Health: A Critical Review. Nutr Today. 2015 May;50(3):117-128. doi: 10.1097/NT.0000000000000092. Epub 2015 Apr 7. PMID: 27340299; PMCID: PMC4890841.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[3] Heymsfield SB, Harp JB, Rowell PN, Nguyen AM, Pietrobelli A. How much may I eat? Calorie estimates based upon energy expenditure prediction equations. Obes Rev. 2006 Nov;7(4):361-70. doi: 10.1111/j.1467-789X.2006.00249.x. PMID: 17038130.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[4] Jackson AS, Stanforth PR, Gagnon J, Rankinen T, Leon AS, Rao DC, Skinner JS, Bouchard C, Wilmore JH. The effect of sex, age and race on estimating percentage body fat from body mass index: The Heritage Family Study. Int J Obes Relat Metab Disord. 2002 Jun;26(6):789-96. doi: 10.1038/sj.ijo.0802006. PMID: 12037649.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[5] Silva AM, Wang J, Pierson RN Jr, Wang Z, Spivack J, Allison DB, Heymsfield SB, Sardinha LB, Heshka S. Extracellular water across the adult lifespan: reference values for adults. Physiol Meas. 2007 May;28(5):489-502. doi: 10.1088/0967-3334/28/5/004. Epub 2007 Apr 5. PMID: 17470983.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[6] Brasil. Ministério da Saúde. Guia alimentar para a população brasileira. 2014.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[7] WHO, FAO, UNU; Nutritional requirements intake.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[8] Institute of Medicine. Dietary Reference Intakes: The Essential Guide to Nutrient Requirements. The National Academies Press. 2006.
          </Typography>

          <Typography component="p" variant="body2" gutterBottom style={{ fontSize: '.75rem' }}>
            &emsp;[9] Advances in Nutrition; Nutrient Information.
          </Typography>

        </Grid>

      </Grid>

        {/* header title bottom*/}
        <Grid container xs={12} sm={12} md={12} lg={10} xl={10}
            justify="center" alignItems="center" alignContent="center"
            //className={classes.grid}
            style={{
              textAlign: "center",
              background:'linear-gradient(135deg, #10B981 33%, #047857 66%, #064E3B 100%)',
              backgroundSize:'200% 200%',
              animation:'gradientMoviment 15s ease infinite',
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 80%)',
              //transform:'rotate(1deg)',
              //borderRadius:'1rem 1rem 0 0',
            }}
          >
            <Typography component="h1" variant="h5" gutterBottom
              style={{
                color:'white',
                fontWeight:'bold',
                fontSize:'2rem',
                //transform:'rotate(-1deg)',
                padding:'1rem 0',
                margin:'0 0 1rem 0',
                lineHeight:'1.75rem'
              }}>
              Cálculo dos Macronutrientes para Planejamento Alimentar
            </Typography>
          </Grid>

        {/* frase */}
        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}
          justify="center" alignItems="center" alignContent="center"
        //style={{backgroundColor:'#374151'}}
        >
          <Typography component="p" variant="body1"
            style={{ padding: '8px 0', textAlign: "center", color: '#111827', fontsize: '.75rem', fontWeight: "300", letterSpacing: '.15rem' }}
          >
            sua saúde é o reflexo da sua alimentação
          </Typography>
        </Grid>

    </Grid>
    
    {/* footer navbar */ }
      <Grid container direction="row" wrap="wrap" justify='center' alignItems="center" alignContent="center"
        xs={12} sm={12} md={12} lg={12} xl={12}
        style={{ backgroundColor: '#ECFDF5', }}
      >
        <Grid container direction="row" wrap="wrap" justify='center' alignItems="center" alignContent="center"
          xs={12} sm={12} md={12} lg={12} xl={12}
          style={{
            margin: 'auto', padding: '16px',
            background: 'linear-gradient(135deg, #10B981 33%, #047857 66%, #064E3B 100%)',
            backgroundSize: '200% 200%',
            animation: 'gradientMoviment 15s ease infinite',
            clipPath: 'polygon(0 0, 100% 20%, 100% 100%, 0 100%)'
          }}
        >
          <Grid container direction="row" wrap="wrap" justify="space-between" alignItems="center" alignContent="center"
            xs={12} sm={12} md={12} lg={10} xl={10}>
            <a href="https://infonutrientes.com.br" rel="noreferrer" target="_blank" style={{textDecoration: 'none'}}>
              <Typography component="h1" variant="h5" gutterBottom
                style={{ color: '#fff', fontWeight: "900", }}
              //border:'1px solid #047857', padding:'4px', borderRadius:'8px', backgroundColor:"#064E3B"
              >
                INFO Nutrientes
              </Typography>
            </a>

            <div>

              <a href="https://www.facebook.com/infonutrientes" rel="noreferrer" target="_blank">
                <FacebookIcon style={{ fill: '#fff', margin: '0 16px 0 0' }} />
              </a>

              <a href="https://www.instagram.com/infonutrientes" rel="noreferrer" target="_blank">
                <InstagramIcon style={{ fill: '#fff' }} />
              </a>

            </div>

          </Grid>
        </Grid>
      </Grid>

    </>
  )
}

export default IndexPage;
